module.exports = {
  ADD_ACTION: 'ADD_ACTION',
  EDIT_ACTIONS: 'EDIT_ACTIONS',
  ACTION_LIST: 'ACTION_LIST',
};
